import rovingTabindex from '../../../core/js/rovingTabindex'

/**
 * Init the interactive components
 */
const component = document.querySelectorAll('.TagsList[role="toolbar"]')

/**
 * Init the roving tabindex for
 * interactive tags
 */
component.forEach((list) => {
  rovingTabindex(list, 'ArrowRight', 'ArrowLeft', '.Tag')
})
